import LayoutContainer from '@Containers/Layout/LayoutContainer';
import { useSessionContext } from '@Containers/SessionContainer';
import React from 'react';
import Title from "./Components/Utilities/Title";

function LoadingComp() {
    return (
        <div className="flex min-h-full flex-col">
            <div className="m-auto w-full text-center">
                <p className="text-5xl text-gray-500">
                    Loading...
                </p>
            </div>
        </div>
    );
}

export default function Loader() {
    const { user } = useSessionContext();

    return (
        <>
            <Title value="Loading…" />

            {user ? (
                <LayoutContainer>
                    <LoadingComp />
                </LayoutContainer>
            ) : <LoadingComp />}
        </>
    );
}
